// extracted by mini-css-extract-plugin
export default {"ProductPromo":"ProductPromo_HH91_","ProductPromo_heading":"ProductPromo_heading_nRwh2","ProductPromo_text":"ProductPromo_text_K2hKg","ProductPromo_link":"ProductPromo_link_X7YTy"};